module.exports = __webpack_public_path__ + "6f58814efb0da9b92063d3693b4450b7.svg";